import { styled, media } from '@creditas-ui/react'

const Container = styled.div`
  position: relative;
  height: 100%;
  margin: 0 20px;

  ${media.up('4xl')} {
    margin-left: 36px;
    margin-right: 36px;
  }

  ${media.up('7xl')} {
    margin-left: 71px;
    margin-right: 71px;
  }
`

export { Container }
